// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QB5G","newExpiryDate":"styles_newExpiryDate__3y0gd","footer":"styles_footer__1Wjxs"};